import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { ExtensionGroupOption } from '../models/extension-group-option';

export const extensionGroupOptionActions = createEagerSelectActions<ExtensionGroupOption>('[Extension Group Options]');
